import type React from 'react';

export interface ProfileHamburgerIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const ProfileHamburgerIcon: React.FC<ProfileHamburgerIconProps> = ({
	width = 27,
	height = 25,
	color = '#F2F0FF',
	'aria-label': ariaLabel = 'Profile Hamburger Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 27 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		role="img"
	>
		<g clipPath="url(#clip0_908_19734)" filter="url(#filter0_d_908_19734)">
			<path
				d="M4.80078 8.99827H18.8092V6.99707H4.80078V8.99827ZM4.80078 13.0007H18.8092V10.9995H4.80078V13.0007ZM4.80078 17.0031H18.8092V15.0019H4.80078V17.0031ZM20.8104 17.0031H22.8116V15.0019H20.8104V17.0031ZM20.8104 6.99707V8.99827H22.8116V6.99707H20.8104ZM20.8104 13.0007H22.8116V10.9995H20.8104V13.0007Z"
				fill={color}
			/>
		</g>
		<defs>
			<filter
				x="-2.20357"
				y="-0.00732422"
				width="32.0195"
				height="32.0195"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4.0024" />
				<feGaussianBlur stdDeviation="2.0012" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				/>
				<feBlend
					mode="normal"
					in2="BackgroundImageFix"
					result="effect1_dropShadow_908_19734"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_dropShadow_908_19734"
					result="shape"
				/>
			</filter>
			<clipPath>
				<rect
					width="24.0144"
					height="24.0144"
					fill="white"
					transform="translate(1.79883 -0.00732422)"
				/>
			</clipPath>
		</defs>
	</svg>
);

export default ProfileHamburgerIcon;
